import { render } from "./MuntersBlue.vue?vue&type=template&id=24379cd2"
import script from "./MuntersBlue.vue?vue&type=script&lang=js"
export * from "./MuntersBlue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__